import React from "react";
import { Link } from "react-router-dom";
import { Lightning, InstagramLogo } from "@phosphor-icons/react";

export function Footer() {
  return (
    <footer className="border-t border-[#27272A] mt-16" data-testid="site-footer">
      {/* Prominent risk disclaimer banner */}
      <div className="bg-[#121212] border-b border-[#27272A]" data-testid="risk-banner">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-4 text-center">
          <p className="text-xs text-[#A1A1AA]">
            <span className="uppercase font-head text-[#FF4500] tracking-wider">Disclaimer:</span>{" "}
            GP Picks is for <strong className="text-white">informational purposes only</strong>. Nothing on this site is a guarantee.
            Any wagers you place are made <strong className="text-white">entirely at your own risk</strong>. Bet responsibly. 18+.
          </p>
        </div>
      </div>

      <div className="py-8 max-w-[1400px] mx-auto px-6 lg:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Lightning size={16} weight="fill" color="#FF4500" />
          <span className="font-head text-sm text-white">GP<span style={{ color: "#FF4500" }}> PICKS</span></span>
          <span className="text-xs text-[#52525b] ml-2">© {new Date().getFullYear()}</span>
        </div>
        <div className="flex flex-wrap items-center gap-5">
          <Link to="/terms" className="overline hover:text-white transition-colors" data-testid="footer-terms">Terms</Link>
          <Link to="/privacy" className="overline hover:text-white transition-colors" data-testid="footer-privacy">Privacy</Link>
          <a
            href="https://instagram.com/gppickdotcom"
            target="_blank"
            rel="noopener noreferrer"
            className="overline hover:text-white transition-colors inline-flex items-center gap-1.5"
            data-testid="footer-support"
          >
            <InstagramLogo size={14} weight="bold" />
            Support · @gppickdotcom
          </a>
        </div>
        <p className="text-[10px] text-[#52525b] max-w-md md:text-right">
          Not a sportsbook. Governed by British Columbia, Canada.
        </p>
      </div>
    </footer>
  );
}
